import { useQuery } from '@tanstack/react-query';
import { getIntegrations, IntegrationsResponse } from '../services/integrationsService';

export const useIntegrations = () => {
  return useQuery<IntegrationsResponse, Error>({
    queryKey: ['integrations'],
    queryFn: getIntegrations,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 3,
  });
}; 